"use client";
import { cn as e } from "../../../utils/utils.mjs";
import * as t from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { cva as i } from "class-variance-authority";
import { Range as a, Root as o, Thumb as s, Track as c } from "@radix-ui/react-slider";
//#region src/components/atoms/Slider/Slider.tsx
var l = i("", { variants: { variant: {
	light: "bg-white",
	dark: "bg-gray-800"
} } }), u = ({ className: i, defaultValue: u, value: d, min: f = 0, max: p = 100, variant: m = "dark", trackProps: h = {}, thumbProps: g = {}, rangeProps: _ = {}, ...v }) => {
	let y = t.useMemo(() => Array.isArray(d) ? d : Array.isArray(u) ? u : [f, p], [
		d,
		u,
		f,
		p
	]);
	return /* @__PURE__ */ r(o, {
		"data-slot": "slider",
		defaultValue: u,
		value: d,
		min: f,
		max: p,
		className: e(["relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", i]),
		...v,
		children: [/* @__PURE__ */ n(c, {
			"data-slot": "slider-track",
			...h,
			className: e("bg-gray-400 relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1", h?.className || ""),
			children: /* @__PURE__ */ n(a, {
				"data-slot": "slider-range",
				..._,
				className: e("absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full", l({ variant: m }), _?.className || "")
			})
		}), Array.from({ length: y.length }, (t, r) => /* @__PURE__ */ n(s, {
			"data-slot": "slider-thumb",
			"aria-label": `slider-thumb-${r + 1}`,
			...g,
			className: e("border-primary bg-background ring-ring/50 block relative size-5 before:absolute before:inset-[-2px] before:content-[''] shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-5 focus-visible:ring-5 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer", g?.className || "")
		}, r))]
	});
};
//#endregion
export { u as Slider };
